import { isTextSelected, onDelegatedClick, formatDate, getTodayYmd, dmyToYmd, ymdFormat, html } from '../functions.js';

export default class NumberElement extends HTMLElement {

    #value = 0;

    #minValue = 0;

    connectedCallback() {

        let newHtml = html`

            <div class="number">
                <button class="number__minus"></button>
                <span class="number__value">0</span>
                <button class="number__plus"></button>
            </div>

        `;

        this.insertAdjacentHTML('beforeend', newHtml);

        this.#bindEvents();

        this.#minValue = parseInt(this.dataset.min) || 0;
        this.#value = parseInt(this.querySelector('input').value);
        this.#refreshUI();
        
    }

    #bindEvents() {
        this.querySelector('.number__minus').addEventListener('click', (event) => {
            this.#decrease();
        });

        this.querySelector('.number__plus').addEventListener('click', (event) => {
            this.#increase();
        });
    }

    #decrease() {
        let value = this.#value;
        value--;

        if (value < this.#minValue) {
            value = this.#minValue;
        }

        this.#value = value;
        this.#refreshValue();
        this.#refreshUI();
        this.#triggerEvent();

    }

    #increase() {
        let value = this.#value;
        value++;

        let max = this.#getMax();

        if (max !== null && value > max) {
            return;
        }

        this.#value = value;

        this.#refreshValue();
        this.#refreshUI();
        this.#triggerEvent();
    }

    #getMax() {
        if (this.dataset.max) {
            return parseInt(this.dataset.max);
        }
        return null;
    }

    #refreshValue() {
        this.querySelector('input').value = this.#value;
    }

    #refreshUI() {
        this.querySelector('.number__value').innerText = this.#value;
    }

    #triggerEvent() {
        this.dispatchEvent(new CustomEvent('change', {
            detail: this.#value
        }));
    }
    


}
window.customElements.define('number-element', NumberElement);

